/* @flow */
import {
    logoutUser,
    openModal,
    setForm,
    emitEvent,
    checkAccess,
} from '../actions';
import InPlayer from '@inplayer-org/inplayer.js';
import {
    NOTIF_SUBSCRIBE_FAIL,
    NOTIF_SUBSCRIBE_SUCCESS,
    LOGIN_FORM,
} from '../constants';
import { notifRequested } from '../middleware/notifications/actions';

export const checkStatus: Function = (response: Object): Object => {
    if (response.status >= 200 && response.status < 300) {
        return response;
    } else {
        let error: Object = new Error(response.statusText);
        error.response = response;
        throw error;
    }
};

export const parseJSON: Function = (response: Object): any => {
    return response.json();
};

export const handleFail: Function = (fail: Function): any => {
    return error => {
        if (error.response) {
            error.response.json().then(fail);
        } else {
            fail(error);
        }
    };
};

export const checkCode: Function = (response: Object): Object => {
    if (response.code && (response.code < 200 || response.code > 300)) {
        return false;
    } else {
        return true;
    }
};

export const handleSocketMessage: Function = (
    message: string,
    dispatch: Function
): any => {
    if (message) {
        const parsedMessage = JSON.parse(message);
        dispatch(emitEvent(parsedMessage.type, parsedMessage.resource));

        switch (parsedMessage.type) {
            case 'access.granted': {
                dispatch(
                    checkAccess(
                        parsedMessage.resource.item.id,
                        parsedMessage.resource.item.merchant_uuid
                    )
                );
                break;
            }
            case 'subscribe.failed': {
                dispatch({
                    type: NOTIF_SUBSCRIBE_FAIL,
                });
                break;
            }

            case 'subscribe.success': {
                dispatch({
                    type: NOTIF_SUBSCRIBE_SUCCESS,
                });
                break;
            }

            case 'payment.card.success': {
                dispatch({
                    type: NOTIF_SUBSCRIBE_SUCCESS,
                });
                break;
            }

            case 'payment.card.failed': {
                dispatch({
                    type: NOTIF_SUBSCRIBE_FAIL,
                });
                break;
            }

            case 'account.logout': {
                dispatch(logoutUser());
                break;
            }

            case 'access.revoked': {
                dispatch(
                    checkAccess(
                        parsedMessage.resource.item.id,
                        parsedMessage.resource.item.merchant_uuid
                    )
                );
                break;
            }
            case 'account.logout': {
                //test whether the token is still valid
                InPlayer.Account.getAccountInfo(
                    InPlayer.Account.getToken().token
                ).then(data => {
                    if (data.errors && data.code === 403) {
                        const callback = () => {
                            dispatch(setForm(LOGIN_FORM, true));
                            dispatch(openModal());
                            dispatch(
                                notifRequested({
                                    title: 'Error',
                                    content:
                                        'You have been logged out because the concurrent sessions limit has been reached.',
                                    type: 'warning',
                                })
                            );
                        };
                        dispatch(logoutUser(callback));
                    }
                });
                break;
            }

            case 'account.erased': {
                dispatch(logoutUser());
                break;
            }

            case 'deactivate.account': {
                dispatch(logoutUser());
                break;
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/utils/api.js